export const FULL_DATE_FORMAT = "YYYY-MM-DD hh:mm A";
export const FULL_DATE_WEEKDAY_FORMAT = "YYYY-MM-DD hh:mm A, ddd";
export const DATE_FORMAT = "YYYY-MM-DD";
export const MONTH_FORMAT = "MMM";
export const TIME_FORMAT = "hh:mm A";
export const TIME_24_HOUR_FORMAT = 'HH:mm';

export const VACATIONS = {
    0: 'Personal',
    1: 'Bereavement',
    2: 'Maternity',
    3: 'Paternity',
    4: 'Sick',
    5: 'Unpaid',
    7: 'WFH',
    8: 'Wedding',
    9: 'Hajj',
    10: 'Military',
    12: 'Long vacation',
    13: 'Emergency',
    14: 'Client visit',
    15: 'Team recreation'
};

export const VACATIONS_FOR_PENDING = [
    {
        name: "All",
        id: "All",
    },
    {
        name: "Personal",
        id: "Personal",
    },
    {
        name: "Maternity",
        id: "Maternity",
    },
    {
        name: "Paternity",
        id: "Paternity",
    },
    {
        name: "Sick",
        id: "Sick",
    },
    {
        name: "WFH",
        id: "WFH",
    },
    {
        name: "Wedding",
        id: "Wedding",
    },
    {
        name: "Hajj",
        id: "Hajj",
    },
    {
        name: "Bereavement",
        id: "Bereavement",
    },
    {
        name: "Long vacation",
        id: "Long vacation",
    },
    {
        name: "Emergency",
        id: "Emergency",
    },
    {
        name: "Unpaid",
        id: "Unpaid",
    },
    {
        name: "Client visit",
        id: "Client visit",
    },
    {
        name: "Team recreation",
        id: "Team recreation",
    },
];


export const FULL_DATE_ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DAY_MONTH_FORMAT = "ddd, D MMM";
export const FULL_DATE_MONTH_LETTERS_FORMAT = "DD MMM, YYYY";
export const FULL_DATE_MONTH_LETTERS_TIME_FORMAT = "DD MMM, YYYY, hh:mm:ss A";
export const DATE_TIME_FORMAT = "MM/DD/YYYY, hh:mm:ss A";
export const WEEK_IN_MS =  7 * 24 * 60 * 60 * 1000;
export const YEAR_FORMAT = 'yyyy';
